"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipAnchor = void 0;
const create_selector_1 = require("../../../state/create_selector");
const get_active_pointer_position_1 = require("../../../state/selectors/get_active_pointer_position");
exports.getTooltipAnchor = (0, create_selector_1.createCustomCachedSelector)([get_active_pointer_position_1.getActivePointerPosition], (pointer) => {
    return {
        x: pointer?.x ?? 0,
        y: pointer?.y ?? 0,
        width: 0,
        height: 0,
    };
});
//# sourceMappingURL=get_tooltip_anchor.js.map